import React from 'react';
import './UiTable.css';
export function UiTable(_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: "UiTable" },
        React.createElement("table", { className: className }, children)));
}
